import { post } from './utils'

export async function createSocialMessage(params) {
  const path = Routes.social_messages_path()
  const response = await post(path, params)
  return response.data
}
